// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"254":"4f8950508ed53645a581","740":"24745be2e19e49ada96e"}[chunkId] + ".css";
};